const packaging: { [key: string]: string } = {
  BA: 'Barrel',
  BE: 'Bundle',
  BG: 'Bag',
  BK: 'Basket',
  BL: 'Bale, compressed',
  BN: 'Bale, non-compressed',
  BR: 'Bar',
  BX: 'Box',
  CA: 'Can, rectangular',
  CG: 'Cage',
  CH: 'Chest',
  CK: 'Cask',
  CL: 'Coil',
  CO: 'Carboy, non-protected',
  CP: 'Carboy, protected',
  CR: 'Crate',
  CS: 'Case',
  CT: 'Carton',
  CX: 'Can, cylindrical',
  CY: 'Cylinder',
  DJ: 'Demijohn, nonprotected',
  DP: 'Demijohn, Protected',
  DR: 'Drum',
  FL: 'Flask',
  FR: 'Frame',
  HD: 'Head',
  HG: 'Hogshead',
  IN: 'Ingot',
  JR: 'Jar',
  JG: 'Jug',
  KG: 'Keg',
  LG: 'Log',
  LZ: 'Logs, in bundle/bunch/truss',
  MT: 'Mat',
  NE: 'Unpacked or unpackaged',
  NT: 'Net',
  PA: 'Packet',
  PC: 'Parcel',
  PE: 'Pen',
  PG: 'Plate',
  PI: 'Pipe',
  PK: 'Package',
  PL: 'Pail',
  PP: 'Pallet',
  PS: 'Piece',
  PT: 'Pipes, in bundle/bunch/truss',
  PU: 'Tray',
  PY: 'Plates, in bundle/bunch/truss',
  PZ: 'Planks, in bundle/bunch/truss',
  RL: 'Reel',
  RO: 'Roll',
  SA: 'sack',
  SD: 'skid',
  SE: 'set',
  SK: 'skeleton case',
  SL: 'slab',
  ST: 'sheet',
  SZ: 'sheet, in bundle/bunch/truss',
  TB: 'Tub',
  TI: 'Tierce',
  TN: 'Tin',
  VA: 'Vat',
  VG: 'Bulk, gas(atlo3lmbarandl5℃)',
  VL: 'Bulk, liquid',
  VO: 'Bulk, solid, large particles(nodules)',
  VP: 'Vanpack',
  VQ: 'Bulk, liguefied gas(at abnomal temperature /pressure)',
  VR: 'Bulk, solid,granular particles(grains)',
  VY: 'Bulk, solid,fine particles(grains)',
  ZZ: 'Other'
};

export default packaging;
